import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import GlobalStyle from "@Styled/Global";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "src/Store/store"; // important to load first store
import { history } from "src/history";
import App from "./App";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { themeMUI } from "./Styled";
import { CookiesProvider } from "react-cookie";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Root element not found");
}

const root = createRoot(rootElement);

root.render(
    <Provider store={store}>
        <HistoryRouter history={history as any}>
            <React.StrictMode>
                <GlobalStyle />
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={themeMUI}>
                        <CookiesProvider>
                            <Suspense
                                fallback={<div>Loading translations...</div>}
                            >
                                <App />
                            </Suspense>
                        </CookiesProvider>
                    </ThemeProvider>
                </StyledEngineProvider>
            </React.StrictMode>
        </HistoryRouter>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
